export enum RequestModeEnum {
  Quotes = "quotes",
  Reservations = "reservations",
}
